import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import {
  MODAL_DATA,
  MODAL_REF,
  ModalRef,
} from '@services/components/ModalService/modal.ref';

export interface CategoryDeleteModalData {
  categoryName: string;
  hasChildren: boolean;
  blockingProducts?: string[];
}

@Component({
  selector: 'app-category-delete-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './category-delete-modal.component.html',
  styleUrl: './category-delete-modal.component.css',
})
export class CategoryDeleteModalComponent {
  private readonly modalRef = inject(MODAL_REF) as ModalRef<boolean>;
  protected readonly data = inject<CategoryDeleteModalData>(MODAL_DATA);

  public get isErrorVariant(): boolean {
    return (this.data?.blockingProducts?.length ?? 0) > 0;
  }

  public onConfirm(): void {
    this.modalRef.close({ reason: 'confirm', data: true });
  }

  public onCancel(): void {
    this.modalRef.close({ reason: 'cancel', data: false });
  }
}
